const dateFormat = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});

window.okeReviewsWidgetOnInit = function () {

	setupAggregateSection();
  
    const warButton = document.querySelector('.okeReviews-reviewsWidget-header-controls-writeReview:not(.is-okeReviews-hidden)');
    const controlsSelect = document.querySelector(".okeReviews-reviews .okeReviews-reviews-controls-sort");
    if (warButton && controlsSelect) {
        controlsSelect.insertAdjacentElement("afterend", warButton);
    }
  
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const observer = new MutationObserver(formatDateForElement);
        observer.observe(reviewMain, {childList: true});
        formatDateForElement();
    }
};

function setupAggregateSection() {
    // Move aggregate section into header
    const destination = document.querySelector(".okeReviews-customAggregateHolder");
    const aggregateSection = document.querySelector(".okeReviews-reviewsWidget-reviewsAggregate.js-okeReviews-reviewsAggregateContainer");
    if (destination && aggregateSection) {
        destination.insertAdjacentElement('afterbegin', aggregateSection);
    }

    const aggregatePrimary = document.querySelector(".okeReviews-reviewsAggregate-primary");
    const ratingDistribution = document.querySelector(".okeReviews-reviewsAggregate-ratingDistribution.js-or-rtgDis");
    // Move rating distribution to aggragate primary
    if (aggregatePrimary && ratingDistribution) {
        aggregatePrimary.insertAdjacentElement('afterbegin', ratingDistribution);
    }

    // Make sure that aggregate is setup before showing
    const reviewHolder = document.querySelector(".okeReviews-widget-holder");
    if (reviewHolder) {
        reviewHolder.style.visibility = "visible";
    }
}

function formatDateForElement() {
    const reviewDates = document.querySelectorAll('[data-oke-reviews-date]');
    for (const reviewDate of reviewDates) {
        const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
        const date = new Date(dateIsoString);
        const localeDate = `${dateFormat.format(date)}`;
        reviewDate.innerText = localeDate;
    }
}